<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          pubs = data?.metaData?.pubs || []
          this.isLoading = false
        }
      "
      contentId="pubs"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Bannière et pubs</div>
      <div>
        <!-- <button class="buttonComponent" @click="saveData" v-if="haveUpdate">
          Enrégister
        </button> -->
      </div>
    </div>
    <div class="py-2"></div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div
        class="md:col-span-3 bg-white rounded-3xl grid md:grid-cols-2 overflow-hidden"
      >
        <div class="p-4 h-min">
          <div class="flex items-center justify-between pb-3">
            <div class="text-3xl title-color">Bannière</div>
            <button class="ripple flex gap-2 items-center" @click="editMainPub">
              <div>Editer</div>
              <div>
                <img src="@/assets/images/all/pen.svg" alt="" class="w-6 h-6" />
              </div>
            </button>
          </div>
          <InputComponent
            v-if="mainPub.description"
            :value="mainPub.description[0]"
            :key="i"
            label="Surtitre"
            disabled
          />
          <InputComponent
            v-for="(title, i) in mainPub.title || []"
            :value="title"
            :key="i"
            disabled
          />
        </div>
        <div class="relative min-h-[45vh] bg-[#2D205F]">
          <img
            v-if="mainPub.picture"
            :src="(mainPub.picture || [])[0]"
            alt=""
            class="w-full h-full object-cover absolute opacity-50"
          />
          <img
            v-if="mainPub.picture"
            :src="(mainPub.picture || [])[0]"
            alt=""
            class="w-full h-full object-contain absolute bg-[#2D205F]"
          />
        </div>
      </div>
      <div
        class="bg-white rounded-3xl p-4 flex flex-col"
        v-for="(pub, i) in smallPubs"
        :key="i"
      >
        <div
          class="flex items-center justify-between pb-3"
          @click="editSmallPub(pub)"
        >
          <div class="title-color">Pub {{ i + 1 }}</div>
          <button class="ripple flex gap-2 items-center">
            <div>Editer</div>
            <div>
              <img src="@/assets/images/all/pen.svg" alt="" class="w-6 h-6" />
            </div>
          </button>
        </div>
        <InputComponent
          v-if="pub.title"
          :value="pub.title[0]"
          :key="i"
          label="Titre"
          disabled
        />
        <InputComponent
          v-if="pub.description"
          :value="pub.description[0]"
          :key="i"
          label="Description"
          disabled
        />
        <InputComponent :value="pub.action" :key="i" label="Bouton" disabled />
        <InputComponent :value="pub.link" :key="i" label="Lien" disabled />
      </div>
    </div>
    <div class="py-2"></div>

    <EventListener
      :events="['pubs_saved', 'failed_to_save_pubs']"
      @pubs_saved="onInfoSaved"
      @failed_to_save_pubs="onFailedToSave"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import InputComponent from '@/components/utils/InputComponent.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    InputComponent,
    EventListener,
  },
  data() {
    return {
      pubs: [],
      updatedData: {},
      isLoading: true,
      haveUpdate: false,
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    async editMainPub() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Editer la Bannière`,
          // subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro du compte: ${account.metadata?.accountId} <br/> Nom de la banque: ${account.metadata?.bankName} <br/> Code de banque: ${account.metadata?.bankCode} <br/> Code Guichet: ${account.metadata?.boxCode}`,
          formFields: [
            {
              type: 'text',
              label: 'Sur titre',
              propertyName: 'description',
              defaultValue: this.mainPub.description[0],
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Premier Texte',
              propertyName: 'title1',
              defaultValue: this.mainPub.title[0],
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Deuxième  Texte',
              propertyName: 'title2',
              defaultValue: this.mainPub.title[1],
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Troisième Texte',
              propertyName: 'title3',
              defaultValue: this.mainPub.title[2],
              required: true,
              class: '',
            },
            {
              type: 'file',
              propertyName: 'picture',
              label: 'Image publicitaire',
              defaultValue: this.mainPub.picture[0],
              class: '',
              alreadyExistPlaceHolder: 'Choisir une autre image',
              inputProps: {
                acceptedFilesTypes: ['image/png', 'image/jpeg'],
              },
              required: true,
            },
          ],
          successText: 'Enrégistrer',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('pub_update_available', {
        ...this.mainPub,
        description: [prompt.data.description],
        title: [prompt.data.title1, prompt.data.title2, prompt.data.title3],
        picture: [prompt.data.picture],
      })
      this.$Events.dispatchEvent('toast_notification', {
        // title: 'Sauvegarde en cours',
        body: 'Sauvegarde en cours',
      })
    },
    async editSmallPub(pub) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Editer la Publicité`,
          // subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro du compte: ${account.metadata?.accountId} <br/> Nom de la banque: ${account.metadata?.bankName} <br/> Code de banque: ${account.metadata?.bankCode} <br/> Code Guichet: ${account.metadata?.boxCode}`,
          formFields: [
            {
              type: 'text',
              label: 'Titre',
              propertyName: 'title',
              defaultValue: pub.title[0],
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Description',
              propertyName: 'description',
              defaultValue: pub.description[0],
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Texte du bouton',
              propertyName: 'action',
              defaultValue: pub.action,
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Lien de redirection',
              propertyName: 'link',
              defaultValue: pub.link,
              required: true,
              class: '',
            },
          ],
          successText: 'Enrégistrer',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('pub_update_available', {
        ...pub,
        description: [prompt.data.description],
        title: [prompt.data.title],
        link: prompt.data.link,
        action: prompt.data.action,
      })
      this.$Events.dispatchEvent('toast_notification', {
        // title: 'Sauvegarde en cours',
        body: 'Sauvegarde en cours',
      })
    },
    onInfoSaved() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Infos enrégistrées correctement',
        body: 'Les informations ont été enrégistrées avec succès',
      })
      this.updatedData = JSON.parse(JSON.stringify(this.pubs))
      this.haveUpdate = false
      setTimeout(() => {
        this.haveUpdate = false
      })
      setTimeout(() => {
        this.haveUpdate = false
      }, 100)
    },
    onFailedToSave() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echec de sauvegarde',
        body: 'Désolé, les données ne sont pas enrégistrée, veuillez réessayer',
      })
    },
    availabilityDisplay(data) {
      return data
    },
  },
  watch: {
    pubs(newVal) {
      if (!this.haveUpdate) {
        this.updatedData = JSON.parse(JSON.stringify(newVal))
        this.haveUpdate = false
        setTimeout(() => {
          this.haveUpdate = false
        })
        setTimeout(() => {
          this.haveUpdate = false
        }, 100)
      }
    },
    updatedData: {
      deep: true,
      handler() {
        this.haveUpdate = true
      },
    },
  },
  computed: {
    mainPub() {
      return this.pubs.find(pub => pub.isMain) || {}
    },
    smallPubs() {
      return this.pubs.filter(pub => !pub.isMain) || new Array(3).fill({})
    },
  },
}
</script>
